import OrderReviewView from './OrderReviewView';

export default OrderReviewView;
